import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import PrivateRoute from "./routes/PrivateRoute";
import MainLayout from "./layouts/MainLayout";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryDetailPage from "./pages/CategoryDetailPage";
import GemDetailPage from "./pages/GemDetailPage";
import GemsListPage from "./pages/GemsListPage";
import ErrorLogsPage from "./pages/ErrorLogsPage";
import TaskManagerPage from "./pages/TaskManagerPage";
import RealOrFakePage from "./pages/RealOrFakePage";
import AdminUsersPage from "./pages/AdminUsersPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/error-logs" element={<ErrorLogsPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route
              path="/categories/:category_uid"
              element={<CategoryDetailPage />}
            />
            <Route path="/gems" element={<GemsListPage />} />
            <Route path="/gems/:uid" element={<GemDetailPage />} />
            <Route path="/tasks" element={<TaskManagerPage />} />
            <Route path="/tasks/:task_id" element={<TaskManagerPage />} />
            <Route path="/real-or-fake" element={<RealOrFakePage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

